import './Buttons.css';
import { Button } from 'react-bootstrap';

const Buttons = ({ back,bactText, handleBack, text, handleSubmit, backClassName, continueClassName }) => {
  return (
    <div className="button-container">
      {back && (
        <Button
          variant="light"
          onClick={handleBack}
          className={`btn btn-back ${backClassName}`}
        >
          {(bactText !== undefined) ? bactText : " Back"}
        </Button>
      )}
      <Button
        variant="primary"
        type="submit"
        onClick={handleSubmit}
        className={`btn btn-continue ${continueClassName}`}
      >
        {(text !== undefined) ? text : "Continue"}
      </Button>
    </div>
  );
};

export default Buttons;
